import { useState, useEffect } from "react";
import { getPostById } from "../APIs/postDetailApi";

const usePostDetail = (postId) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!postId) return;
    const fetch = async () => {
      setLoading(true);
      try {
        const data = await getPostById(postId);
        setPost(data);
      } catch (err) {
        setError("Post not found.");
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [postId]);

  return { post, loading, error };
};

export default usePostDetail;